import { h } from 'preact';
import { joinClasses } from 'utils/utils';
import { navigateInternally } from 'utils/bolt/index';
import Store from 'store/store';
import Button from 'components/bolt/button/button';
import Countdown from 'components/bolt/countdown/countdown';
import * as BaseComp from 'components/bolt/header/headerExpanded.js';
import s from 'components/bolt/header/headerExpanded.sss';

export default class HeaderExpanded extends BaseComp.default {
	renderStandardLinks() {
		return (
			<div class={s.standard} key="standard">
				<a
					href="/"
					onClick={(e) => {
						e.preventDefault();
						navigateInternally('/');
					}}
				>
					{this.renderTT()}
				</a>
				<div class={s.standardLinks}>{this.standardLinks.map((link) => this.renderLink(link, false))}</div>
				{/* TODO: ADD SOUND TOGGLE CALLBACK */}
			</div>
		);
	}

	render(props) {
		const { appData, calRemindOpen, navOpen } = props;
		const { copy, options } = appData;
		return (
			<div class={joinClasses(s.container, navOpen && s.open)}>
				<div class={s.links}>
					{this.renderLinks()}
					<div class={s.nextService}>
						<p>{copy.siteCopy.nextServiceLabel}</p>
						{options.showCalendarInvite && <Countdown datetime={copy.siteCopy.liveStreamDate} />}
						{options.showCalendarInvite ? (
							<Button
								class={joinClasses(s.remindBtn, calRemindOpen && s.remindBtnActive, s.saveCalendar)}
								trigger={() => {
									Store.emit('TRACK_CALENDAR_BUTTON_CLICK');
									Store.emit('CLOSE_NAV_MENU');
									navigateInternally('@calendarreminder');
								}}
							>
								{copy.siteCopy.calendarReminder}
							</Button>
						) : (
							<div></div>
						)}
					</div>
				</div>
			</div>
		);
	}
}
